// src/sot/primitives/TopBar.jsx
import React from "react";

export const TOP_BAR_TITLE_CLASS_NAME = "text-headline-small text-on-surface";

/**
 * TopBar
 * - Rounded-corner (not circular) back button
 * - Title block below the row (keeps spacing predictable)
 * - Optional subtitle + trailing slot (Save, etc)
 * - Uses "Title Large" (Inter 22/28 • 400) to match TopBarCenter
 *
 * ✅ Global top breathing room is handled INSIDE TopBar
 * ✅ Safe-area aware (iOS notch)
 */
export default function TopBar({
  title = "",
  subtitle = "",
  onBack,
  leading = null,
  trailing = null,
  trailingAlign = "top", // "top" | "title"
  titleClassName = `${TOP_BAR_TITLE_CLASS_NAME} truncate`,
  titleWrapperClassName = "mt-1 mb-6",
  showNavigationRow = true,
  backLabel = "Back",
}) {
  return (
    <header className="w-full">
      {/* ✅ Global head air + safe-area (applies everywhere TopBar is used) */}
      <div style={{ height: "env(safe-area-inset-top)" }} />

          {trailingAlign === "title" ? (
            <div className="w-full">
              {/* Row 1: title + trailing aligned together */}
              <div className="flex items-center justify-between">
                <div className="min-w-0">
                  {!!title && (
                    <h1
                      className={titleClassName}
                      style={{ fontWeight: 400 }}
                    >
                      {title}
                    </h1>
                  )}
                </div>

                <div className="ml-3 shrink-0">{trailing}</div>
              </div>

              {/* Row 2: subtitle below */}
              {!!subtitle && (
                <p className="mt-1 text-body-medium leading-[20px] text-[rgb(var(--clr-on-surface-variant))]">
                  {subtitle}
                </p>
              )}
            </div>
          ) : (
            <>
          {/* Navigation/action row is optional for in-rail section headers. */}
          {showNavigationRow ? (
            <div className="flex h-14 items-center justify-between">
              {leading ? (
                leading
              ) : onBack ? (
                <button
                  type="button"
                  aria-label={backLabel}
                  onClick={onBack}
                  className={[
                    "inline-flex items-center justify-center",
                    "topbar-back",
                    "h-10 w-10 rounded-[12px]",
                    "text-on-surface",
                  ].join(" ")}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M15 18l-6-6 6-6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              ) : (
                <div className="h-10 w-10" />
              )}

              <div className="ml-auto">{trailing}</div>
            </div>
          ) : null}

          {/* title block – match TopBarCenter spacing */}
          <div className={titleWrapperClassName}>
            {!!title && (
              <h1
                className={titleClassName}
                style={{ fontWeight: 400 }}
              >
                {title}
              </h1>
            )}
            {!!subtitle && (
              <p className="mt-1 text-body-medium leading-[20px] text-[rgb(var(--clr-on-surface-variant))]">
                {subtitle}
              </p>
            )}
          </div>
        </>
      )}
    </header>
  );
}
